export default {
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},
};



// WEBPACK FOOTER //
// ./src/store/Task/modules/task-list.js